import { render, staticRenderFns } from "./InteractWithContractContainer.vue?vue&type=template&id=08eb788a&scoped=true&"
import script from "./InteractWithContractContainer.vue?vue&type=script&lang=js&"
export * from "./InteractWithContractContainer.vue?vue&type=script&lang=js&"
import style0 from "./InteractWithContractContainer.vue?vue&type=style&index=0&id=08eb788a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08eb788a",
  null
  
)

export default component.exports